export default __webpack_public_path__ + "static/media/Header Backgoround.b21808bc.png";